import React from "react";

export default function StudentCareerSection() {
  const listings = [
    {
      title: "XR Developer",
      source: "Summer",
      href: "mailto:studio@norcat.org?subject=[ JOB APPLICATION ] Student XR Developer",
    },
    {
      title: "3D Artist",
      source: "Summer",
      href: "mailto:studio@norcat.org?subject=[ JOB APPLICATION ] Student 3D Artist",
    },
    {
      title: "Front-End Developer",
      source: "Summer",
      href: "mailto:studio@norcat.org?subject=[ JOB APPLICATION ] Front-End Developer",
    },
    {
      title: "Software Developer",
      source: "Summer",
      href: "mailto:studio@norcat.org?subject=[ JOB APPLICATION ] Software Developer",
    },
  ];

  return (
    <section className="press-section careers-student-section">
      <style>{`
        .press-section{
          background:#000;
          padding: 6.5rem 0;
          padding-bottom: 10rem;
          margin-top: -7.5rem;
          width:100%;
        }

        .press-kicker{
          font-size: 1.15rem;
          letter-spacing: .14rem;
          text-transform: uppercase;
          color: rgba(255,255,255,.55);
          margin-bottom: 1.6rem;
        }

        .press-list{
          width:100%;
          border-top: 1px solid rgba(255,255,255,.18);
        }

        /* clickable row */
        .press-row{
          width:100%;
          display:grid !important;
          grid-template-columns: 2fr 1fr;
          align-items:center;
          gap: 2.2rem;

          padding: 2rem 0;
          border-bottom: 1px solid rgba(255,255,255,.18);
          position:relative;

          background: transparent;
          text-decoration: none;

          cursor: pointer;
          user-select: none;
          -webkit-user-select: none;

          transition: background .25s ease;
        }

        /* left accent bar on hover */
        .press-row::before{
          content:"";
          position:absolute;
          left:-18px;
          top:14px;
          bottom:14px;
          width:0;
          opacity:0;
          border-radius:999px;
          background: var(--slope-main-color, #EA0029);
          transition: width .25s ease, opacity .25s ease;
        }

        /* only red highlight + subtle bg */
        .press-row:hover{
          background: rgba(255, 255, 255, 0);
        }
        .press-row:hover::before{
          width:6px;
          opacity:1;
        }

        /* typography */
        .press-title{
          font-size: 1.33rem;
          line-height: 3rem;
          font-weight: 700;
          color: rgba(255,255,255,.92);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .press-meta{
          display:flex;
          justify-content:flex-end;
          align-items:center;
          gap: 1.2rem;
          white-space: nowrap;
          min-width: 0;
        }

        .press-source{
          font-size: 1.33rem;
          line-height: 3rem;
          font-weight: 600;
          color: rgba(255,255,255,.55);
        }

        /* external link icon button */
        .press-iconBtn{
          width: 36px;
          height: 36px;
          border-radius: 999px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: rgba(255,255,255,0);
          transition: background .25s ease;
          flex: 0 0 auto;
        }
        .press-row:hover .press-iconBtn{
          background: rgba(255,255,255,.08);
        }

        .press-icon{
          width: 16px;
          height: 16px;
          display:block;
          opacity: .95;
        }
        .press-icon path{
          stroke: #fff;
        }

        /* focus */
        .press-row:focus{ outline: none; }
        .press-row:focus-visible{
          outline: 2px solid rgba(255,255,255,.35);
          outline-offset: 6px;
          border-radius: 6px;
        }

        /* mobile */
        @media (max-width: 767px){
          .press-row{
            grid-template-columns: 1fr;
            gap: .55rem;
            padding: 1.7rem 0;
          }
          .press-meta{
            justify-content:flex-start;
          }
          .press-row::before{
            left:-14px;
          }
        }
      `}</style>

      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="press-kicker">STUDENT OPPORTUNITIES</div>

            <div className="press-list">
              {listings.map((p, i) => (
                <a
                  className="press-row"
                  key={`${p.title}-${i}`}
                  href={p.href}
                  aria-label={`Apply by email for ${p.title} (${p.source})`}
                >
                  <div className="press-title">{p.title}</div>

                  <div className="press-meta">
                    <span className="press-source">{p.source}</span>

                    <span className="press-iconBtn" aria-hidden="true">
                      <svg className="press-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M14 5h5v5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M10 14L19 5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M19 14v5H5V5h5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
